import React from "react";

import { IColumnData } from "Modules/DS/DataTable";

import { InputCell } from "Views/Transaction/Shimmer";
import { CellWithSubtitle } from "Views/Transaction/List";
import { ALL_TRXNS_COLUMNS, TRANSACTION_TYPES } from "Views/Transaction/Constants";
import { IGetTrxnResponse, GET_TRXN_RESPONSE_PARAMS } from "Views/Transaction/@types";

export const RequesterCell = ({ children }: { children: IGetTrxnResponse }) => {
  const title = children.type === TRANSACTION_TYPES.TRANSFER ? children.description : children.payer_name;
  return (
    <InputCell>
      <CellWithSubtitle title={title} />
    </InputCell>
  );
};

export const requester = (): IColumnData<IGetTrxnResponse>["column"] => ({
  title: ALL_TRXNS_COLUMNS.REQUESTER,
  width: 120,
  dataIndex: GET_TRXN_RESPONSE_PARAMS.PAYER_ID,
  key: GET_TRXN_RESPONSE_PARAMS.PAYER_ID,
  render: (_, record: IGetTrxnResponse) => <RequesterCell>{record}</RequesterCell>,
});
